import {
  DECLARATION_STATUS_CANCELLED, DECLARATION_STATUS_FAILED, DECLARATION_STATUS_PRECANCELLED,
  DECLARATION_STATUS_PRESUBMITTED,
  DECLARATION_STATUS_SUBMITTED
} from './AppConstants';

const apiVersion = 'v1';
const apiBaseUrl = process.env.NMSW_DATA_API_BASE_URL || 'http://localhost:5000';
const apiUrl = `${apiBaseUrl}/${apiVersion}`;
const spcrApiBaseUrl = process.env.SPCR_DATA_API_BASE_URL || 'http://localhost:5001';
const spcrApiUrl = `${spcrApiBaseUrl}/${apiVersion}`;

export const API_URL = apiUrl;

// SPCR Endpoints
export const SPCR_REPORT_ENDPOINT = `${spcrApiUrl}/internal/voyagereports`; // spcr-data-api::/v1/internal/voyagereports/:reportId
export const SPCR_VOYAGES_ENDPOINT = `${spcrApiUrl}/internal/voyagereports`;
export const SPCR_VOYAGES_DOWNLOAD_ENDPOINT = `${spcrApiUrl}/internal/voyagereports/download`;
export const PORTS_URL = `${spcrApiUrl}/internal/ports`;
export const TEAM_PORTS_URL = `${spcrApiUrl}/internal/ports?team=`;
export const PORTS_SEARCH_URL = `${spcrApiUrl}/internal/ports?search=`;

// Endpoint Paths
export const ENDPOINT_DECLARATION_PATH = '/declaration';
export const ENDPOINT_DECLARATION_ATTACHMENTS_PATH = '/attachments';
export const ENDPOINT_DECLARATION_PEOPLE_PATH = '/people';
export const PRE_SIGNED_URL = 'presigned-url';

// Endpoints
export const DECLARATIONS_ENDPOINT = `${apiUrl}${ENDPOINT_DECLARATION_PATH}`;
export const PASSSWORD_RESET_ENDPOINT = `${apiUrl}/reset-password`;
export const RESEND_INVITE_ENDPOINT = `${apiUrl}/resend-verification-email`;
export const REGISTER_ACCOUNT_ENDPOINT = `${apiUrl}/invite`;
export const REGISTER_CHECK_TOKEN_ENDPOINT = `${apiUrl}/check-token`;
export const REGISTER_RESEND_VERIFICATION_EMAIL_ENDPOINT = `${apiUrl}/resend-verification-email`;
export const SIGN_IN_ENDPOINT = `${apiUrl}/sign-in`;
export const SIGN_OUT_ENDPOINT = `${apiUrl}/sign-out`;
export const TEAM_INVITE_ENDPOINT = `${apiUrl}/invite`;
export const USER_ENDPOINT = `${apiUrl}/user`;
export const GROUP_USERS_ENDPOINT = `${apiUrl}/users/by-group`;
export const DELETE_TEAM_MEMBER_ENDPOINT = `${apiUrl}/user/`;

// Viewing people / UPT Status
export const ENDPOINT_PEOPLE = '/people';
export const QUERY_IS_TRAVELLING = 'is_travelling';
export const QUERY_IS_CREW = 'is_crew';
export const ENDPOINT_CREW_PATH = `${ENDPOINT_PEOPLE}?${QUERY_IS_CREW}=True&${QUERY_IS_TRAVELLING}=True`;
export const ENDPOINT_PASSENGERS_PATH = `${ENDPOINT_PEOPLE}?${QUERY_IS_CREW}=False&${QUERY_IS_TRAVELLING}=True`;

// People Query Params
export const UPT_STATUS_PART = 'response_sector';
export const UPT_SEARCH_PART = 'search';
export const UPT_RESPONSE_CODES = 'response_codes';
export const UPT_SYSTEM_TIME_CODE = '0T';

// Endpoint Query Params
export const PAGINATION_PATH_PART = 'page_start';
export const DEPARTURE_PATH_PART = 'departure';
export const STATUS_PATH_PART = 'status';
export const TEAM_PATH_PART = 'team';
export const PER_PAGE_PATH_PART = 'per_page';
export const SEARCH_PATH_PART = 'search';
export const IS_CREW_PARTH_PART = 'is_crew';
export const NMSW_PER_PAGE = 'per_page'
export const NMSW_DEFAULT_PAGE_SIZE = '50';

// Endpoint Query Param Default Values
export const DEFAULT_DECLARATION_STATUSES = [
  DECLARATION_STATUS_SUBMITTED,
  DECLARATION_STATUS_PRESUBMITTED,
  DECLARATION_STATUS_CANCELLED,
  DECLARATION_STATUS_PRECANCELLED,
  DECLARATION_STATUS_FAILED
];

export const DEFAULT_DECLARATION_QUERY_PARAMS = {
  [DEPARTURE_PATH_PART]: false,
  [STATUS_PATH_PART]: DEFAULT_DECLARATION_STATUSES,
  [NMSW_PER_PAGE]: NMSW_DEFAULT_PAGE_SIZE
};

// NMSW Responses
export const TOKEN_ARLEADY_USED = 'Token was already used';
export const TOKEN_EXPIRED_OR_INVALID = 'Token is invalid or it has expired';
export const USER_ALREADY_REGISTERED = 'User is already registered';
export const USER_ALREADY_VERIFIED = 'User already verified';
export const USER_ALREADY_VERIFIED_LOGIN = 'User already verified, please login';
export const USER_NOT_AUTHORISED = 'User is not registered';
export const USER_NOT_VERIFIED = 'User not verified, please verify registration';
export const USER_HAS_NOT_BEEN_VERIFIED = 'User has not been verified yet';
export const USER_SIGN_IN_DETAILS_INVALID = 'Email or password invalid';
export const VALID_PERMISSION_MESSAGE = 'VALID PERMISSION TO TRAVEL';
export const NO_RECORD_MESSAGE = 'NO RECORD OF VALID PERMISSION TO TRAVEL';
export const AUTHORITY_GRANTED = 'AUTHORITY TO CARRY GRANTED';
export const SYSTEM_TIME_OUT = 'SYSTEM TIME OUT';

// SPCR-endpoint paths
export const RISK_ASSESSMENT = 'risk-assessment';
export const RECORD_OUTCOME = 'record-outcome';
export const COMMENT = 'comment';
